import { BusIframe } from '@main/bus-layer/bus-iframe';
import type { BusEvent } from '@main/utils/bus-event-promisifier';
import { BusEventsPromisifier } from '@main/utils/bus-event-promisifier';
import { Logger } from '@main/utils/logger';
import type { HangupTransferCallEventPublisher } from './hangup-transfer-call.usecase';

export class HangupTransferCallPublisher
  implements HangupTransferCallEventPublisher
{
  private logger: Logger;
  constructor() {
    this.logger = new Logger();
  }

  async publish(): Promise<void> {
    const busIframe = await BusIframe.getIframe();
    const busEvent: BusEvent = {
      type: 'DIALER.HANGUP',
    };

    this.logger.info('Publisher: Hangup call', {
      action: 'HangupCall',
    });

    return BusEventsPromisifier.promisifyFireAndForgetEvent({
      target: busIframe,
      event: busEvent,
    });
  }
}
